import { render, staticRenderFns } from "./dingding.vue?vue&type=template&id=25907306&"
import script from "./dingding.vue?vue&type=script&lang=ts&"
export * from "./dingding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports